import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Search } from "lucide-react";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid, Cell } from "recharts";

const PALETTE = ["#0284C7", "#0EA5E9", "#38BDF8", "#7DD3FC", "#BAE6FD"];

export default function SearchFrequencyPanel() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/stats/search-frequency?limit=8").then((r) => setData(r.data)).catch(() => {}); }, []);
  if (!data) return null;
  if (data.top.length === 0) {
    return (
      <Card className="border-slate-200/70 card-elevated" data-testid="search-freq-empty">
        <CardContent className="p-6 flex items-center gap-3 text-slate-500">
          <div className="w-11 h-11 rounded-xl bg-sky-100 text-sky-700 flex items-center justify-center">
            <Search className="w-5 h-5" />
          </div>
          <div>
            <div className="font-black text-slate-900">أكثر البحوث تكراراً</div>
            <div className="text-xs">ابدأ باستخدام البحث الذكي لترى أنماط الاستعلامات هنا</div>
          </div>
        </CardContent>
      </Card>
    );
  }
  const chart = data.top.map((x) => ({ query: x.query.length > 26 ? x.query.slice(0, 26) + "…" : x.query, count: x.count }));
  return (
    <Card className="border-slate-200/70 card-elevated" data-testid="search-freq-panel">
      <CardContent className="p-6">
        <div className="flex items-center gap-3 mb-4">
          <div className="w-11 h-11 rounded-xl bg-sky-100 text-sky-700 flex items-center justify-center">
            <Search className="w-5 h-5" />
          </div>
          <div>
            <div className="font-black text-slate-900">أكثر البحوث تكراراً</div>
            <div className="text-xs text-slate-500">إجمالي {data.total} استعلاماً — أعلى {data.top.length}</div>
          </div>
        </div>
        <div className="h-56" dir="ltr">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={chart} layout="vertical" margin={{ top: 5, right: 8, left: 0, bottom: 0 }}>
              <CartesianGrid strokeDasharray="3 3" stroke="#E2E8F0" horizontal={false} />
              <XAxis type="number" allowDecimals={false} tick={{ fill: "#475569", fontSize: 11 }} />
              <YAxis type="category" dataKey="query" width={180} tick={{ fill: "#334155", fontSize: 11 }} />
              <Tooltip contentStyle={{ borderRadius: 12, borderColor: "#E2E8F0" }} />
              <Bar dataKey="count" radius={[0, 8, 8, 0]} maxBarSize={22}>
                {chart.map((_, i) => <Cell key={i} fill={PALETTE[i % PALETTE.length]} />)}
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </div>
      </CardContent>
    </Card>
  );
}
